module.exports = __webpack_public_path__ + "static/media/golive.83ca3a75.png";